export const BASE_URL = "https://api.spotify.com/v1/";

export const unknownArtistImageUrl = "https://thumbs.dreamstime.com/b/default-avatar-profile-flat-icon-social-media-user-vector-portrait-unknown-human-image-default-avatar-profile-flat-icon-184330869.jpg";